import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsPage.css';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-page">
      <div className="terms-container">
        <button className="terms-back-button" onClick={() => navigate('/')}>
          ← Back to Map
        </button>

        <h1>Terms and Conditions</h1>

        <div className="terms-content">
          <p className="last-updated">Last updated: January 2025</p>

          <section>
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using anicha.earth (the "Service"), you accept and agree to be bound by these Terms and Conditions.
              If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section>
            <h2>Service Description</h2>
            <p>
              anicha.earth provides access to satellite imagery from Sentinel-2 satellites, processed and enhanced using AI technology.
              The Service is provided for informational and educational purposes.
            </p>
          </section>

          <section>
            <h2>Beta Testing</h2>
            <p>
              This Service is currently in beta testing. Features may change, and the Service may experience downtime or errors.
              We make no guarantees about the availability, accuracy, or reliability of the Service.
            </p>
          </section>

          <section>
            <h2>Data Usage</h2>
            <p>
              The satellite imagery provided by this Service is derived from Sentinel-2 data, which is made available through the
              European Space Agency's Copernicus program. Enhanced imagery is processed using our proprietary AI models.
            </p>
          </section>

          <section>
            <h2>User Conduct</h2>
            <p>
              You agree to use the Service only for lawful purposes. You shall not:
            </p>
            <ul>
              <li>Attempt to gain unauthorized access to the Service or its systems</li>
              <li>Use the Service to violate any applicable laws or regulations</li>
              <li>Overload or disrupt the Service infrastructure</li>
              <li>Resell or redistribute data obtained from the Service without permission</li>
            </ul>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <p>
              The Service, including its original content, features, and functionality, is owned by anicha.earth and is protected
              by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2>Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED,
              INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
            </p>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>
              IN NO EVENT SHALL ANICHA.EARTH BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
              OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL,
              OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section>
            <h2>Privacy</h2>
            <p>
              We collect minimal user data necessary for Service operation, including analytics data to improve the Service.
              We do not sell or share your personal information with third parties.
            </p>
          </section>

          <section>
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon
              posting. Your continued use of the Service after changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at{' '}
              <a href="mailto:konstantin@anicha.earth">konstantin@anicha.earth</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
